import React from "react";
import Hero from "./Hero";
import HeroForm from "./HeroForm";
import About from "./About";
import Service from "./Service";
import AfterSurgery from "./AfterSurgery";
import Blog from "./Blog";
import Detail from "./Detail";
import Testimonial from "./Testimonial";
import BookingForms from "./BookingForms";
import Transform from "./Transform";
import AboutTwo from "./AboutTwo";
import Faq from "./Faq";
import HeroUpperForm from "./HeroUpperForm";
import Section from "./Section";
import Testimo from "./Testimo";
import AboutUs from "./AboutUs";
import ServiceSection from "./ServiceSection";
import WeOffers from "./WeOffers";
import Blogs from "./Blogs";
import Transforms from "./Transforms";
import SectionAdd from "./SectionAdd";
import WhyUs from "./WhyUs";

const Home = () => {
  return (
    <div>
      <Hero />
      <HeroForm />
      <AboutUs />

      {/* <WeOffers />  */}
      <ServiceSection />
      {/* <AboutTwo /> */}
      <Service />
      <Transforms />
      <WhyUs />

      {/* <Detail /> */}
      <AfterSurgery />
      <Blog />
      <BookingForms />
      <Testimo />

      {/* <Blogs /> */}
      <SectionAdd />

      {/* <Section/> */}
      {/* <Testimonial /> */}
      <Faq />

      {/* <HeroUpperForm/> */}
      {/* <About /> */}
      {/* <WhyUs/> */}
      {/* <Transform/> */}
    </div>
  );
};

export default Home;
